<template>
  <v-sheet
    class="d-flex align-center justify-center"
    :height="height"
    :width="width"
  >
    <v-container>
      <v-slide-y-reverse-transition group>
        <v-layout key="circle" justify-center v-if="show">
          <v-card
            class="d-flex align-center justify-center"
            color="indigo darken-2"
            elevation="10"
            rounded="circle"
            height="250"
            width="250"          
          >
            <v-icon color="white" size="120">
              mdi-check
            </v-icon>
          </v-card>
        </v-layout>

        <p
          class="text-center mt-10" 
          key="message"
          style="color: indigo; white-space: pre-wrap;"
          v-if="show"
        >
          {{message}}
        </p>
      </v-slide-y-reverse-transition>
    </v-container>
  </v-sheet>
</template>

<script>
import windowSizeMixin from '../mixin/windowSizeMixin'
import isBrowserJapanese from '../mixin/isBrowserJapanese'

export default {
  mixins: [isBrowserJapanese, windowSizeMixin],
  computed: {
    message: function(){
      if(this.isBrowserJapanese){
        return `登録完了\n\n"${this.mail}" にGithubレポジトリへの招待を送信しました。\nブラウザを閉じて、メールからリポジトリにアクセスしてください。`;
      }else{
        return `Registration Complete !!\n\n We have sent you an invitation for Github Repository.\nPlease close this page and access the repository from the e-mail.`
      }
    },
  },
  created: function(){
    setTimeout(() => {
      this.show = true;
    }, 500);
    this.mail = this.$route.query.mail;
  },
  data: ()=>({
    mail: '',
    show: false,
  }),
}
</script>